const assetsMessages = {
  en: {
    // Tree
    'assets.tree.title': 'COMPONENT TREE',
    'assets.tree.expandAll': 'Expand All',
    'assets.tree.collapseAll': 'Collapse All',
    'assets.tree.search': 'Search...',
    'assets.tree.expand': 'Expand',
    'assets.tree.collapse': 'Collapse',

    // Detail header
    'assets.detail.noTemplate': 'No template selected',
    'assets.detail.partOfGroup': 'Part of {group} group in {collection} collection',
    'assets.detail.contents': 'Contents',
    'assets.detail.overview': 'Overview',
    'assets.detail.contentsEmpty': 'No child components yet. Use “Add Component” to add one.',

    // Sections
    'assets.sections.dailyTasks': 'Daily Tasks',
    'assets.sections.preventiveMaintenance': 'Preventive Maintenance',
    'assets.sections.projects': 'Work Orders',
    'assets.sections.inventory': 'Inventory',
    'assets.sections.instructions': 'INSTRUCTIONS',
    'assets.sections.searchTasks': 'Search tasks\u2026',
    'assets.sections.searchWorkOrders': 'Search work orders\u2026',
    'assets.sections.searchClear': 'Clear search',
    'assets.sections.searchEmpty': 'Nothing matches “{term}”.',

    // Actions
    'assets.actions.add': 'Add',
    'assets.actions.addComponent': 'Add Component',
    'assets.actions.newTemplate': 'New Template',
    'assets.actions.newGroup': 'New Group',
    'assets.actions.newAsset': 'New Sub-Asset',
    'assets.actions.newTask': 'New Task',
    'assets.actions.edit': 'Edit',
    'assets.actions.save': 'Save',
    'assets.actions.cancel': 'Cancel',
    'assets.actions.export': 'Export',
    'assets.actions.archive': 'Archive',
    'assets.actions.unarchive': 'Unarchive',

    // Archive confirmation
    'assets.archive.confirmTitle': 'Archive {typeLabel}?',
    'assets.archive.confirmText':
      'This hides “{name}” from the items list. It is not deleted, and it can be restored.',
    'assets.archive.confirmTextTask':
      'This removes “{name}” from this asset. It is not deleted, and it can be restored.',
    'assets.archive.childWarning':
      'Its {count, plural, one {# child component is not archived — it stays} other {# child components are not archived — they stay}} active, but will no longer be reachable through this {typeLabel}.',
    'assets.archive.failed': 'Could not archive this component. Please try again.',
    'assets.archive.confirm': 'Archive',
    'assets.archive.cancel': 'Cancel',
    'assets.archive.archivedBadge': 'Archived',
    'assets.archive.typeLabel.template': 'template',
    'assets.archive.typeLabel.group': 'group',
    'assets.archive.typeLabel.item': 'item',
    'assets.archive.typeLabel.task': 'task',

    // Tasks
    'assets.task.frequency': 'Frequency',
    'assets.task.check': 'Check',
    'assets.task.photoReq': 'Photo Req.',
    'assets.dailyTasks.addInline': 'Add a daily task',

    // PM
    'assets.pm.procedure': 'PROCEDURE',
    'assets.pm.partsNeeded': 'PARTS NEEDED',

    // Work Orders
    'assets.projects.empty': 'No work orders yet',
    'assets.projects.emptyDescription': 'Add work orders like "Replace motor" or "Install VFD"',
    'assets.projects.addProject': 'Add Work Order',

    // Inventory
    'assets.inventory.requiredQty': 'Required qty',
    'assets.inventory.qty': 'Qty',
    'assets.inventory.lowStockAlert':
      '{count, plural, one {# item} other {# items}} below reorder threshold',
    'assets.inventory.viewDetails': 'View Details',

    // Tree section labels
    'assets.view.tree': 'Tree view',
    'assets.view.list': 'List view',
    'assets.view.card': 'Card view',
    'assets.list.name': 'Name',
    'assets.list.description': 'Description',
    'assets.list.area': 'Area',
    'assets.list.workOrders': 'Work Orders',
    'assets.list.status': 'Status',
    'assets.type.template': 'Template',
    'assets.type.group': 'Group',
    'assets.type.item': 'Sub-Asset',
    'assets.type.collection': 'Collection',
    'assets.list.back': 'Back to My Assets',
    'assets.list.edit': 'Edit',
    'assets.cart.title': 'Assets Summary',
    'assets.cart.selectedFor': 'Selected for {site}',
    'assets.cart.add': 'Add',
    'assets.cart.inCart': 'In cart',
    'assets.cart.added': 'Added',
    'assets.cart.cancel': 'Cancel',
    'assets.cart.remove': 'Remove from cart',
    'assets.cart.clear': 'Clear cart',
    'assets.cart.removeFromSite': 'Remove from site',
    'assets.cart.removeTitle': 'Remove template from site',
    'assets.cart.removeText':
      'Remove {name} from this site? Its open tasks and inventory are archived; completed history is kept.',
    'assets.cart.removeConfirm': 'Remove',
    'assets.cart.empty': 'No templates selected yet.',
    'assets.cart.submit': 'Add assets to site',
    'assets.cart.adding': 'Adding...',
    'assets.list.editHint': 'Select templates to add to this site',
    'assets.list.empty': 'No templates added to this site yet. Use Edit to add some.',
    'assets.card.noArea': 'No area',
    'assets.status.operational': 'Operational',
    'assets.status.maintenance': 'Maintenance',
    'assets.status.offline': 'Offline',
    'assets.status.none': 'Null',
    'assets.card.workOrders': '+{count, plural, one {# work order} other {# work orders}}',
    'assets.card.noWorkOrders': '0 work orders',
    'assets.tree.templates': 'TEMPLATES',
    'assets.tree.groups': 'GROUPS',
    'assets.tree.assets': 'SUB-ASSETS',
    'assets.tree.untitledGroup': 'Untitled Group',
    'assets.tree.untitledAsset': 'Untitled Sub-Asset',

    // Tree (template selected view)
    'assets.tree.componentTree': 'SELECTED TEMPLATE',

    // Empty state
    'assets.selectNode': 'Select a component to view its details',
    'assets.selectTemplate': 'Select a template to view its component tree',

    // Add Template Drawer
    'assets.template.drawerTitle': 'Add Template',
    'assets.template.name': 'Template Name',
    'assets.template.namePlaceholder': 'e.g., Top Brush Assembly',
    'assets.template.nameRequired': 'Template name is required',
    'assets.template.description': 'Description',
    'assets.template.descriptionPlaceholder': 'Describe the purpose of this template...',
    'assets.template.type': 'Area',
    'assets.template.typePlaceholder': 'Select an area',
    'assets.template.typeRequired': 'Area is required',
    'assets.template.image': 'Image',
    'assets.template.removeImage': 'Remove image',
    'assets.template.version': 'Version',
    'assets.template.versionPlaceholder': 'e.g., v1',
    'assets.template.defaultStatus': 'Default status',
    'assets.template.canTriggerWashdown': 'Can trigger washdown',
    'assets.template.addTemplate': 'Add Template',
    'assets.template.saveTemplate': 'Save Template',

    // Node Action Drawer
    'assets.drawer.addTo': 'Add to {nodeName}',
    'assets.drawer.whatAdding': 'What are you adding?',
    'assets.drawer.type.dailyTask': 'Daily Task',
    'assets.drawer.type.prevMaint': 'Prev. Maint.',
    'assets.drawer.type.project': 'Work Order',
    'assets.drawer.type.inventory': 'Inventory',

    // Task sub-mode toggle (only shown when adding a task under a group or item)
    'assets.drawer.taskSource': 'How would you like to add this task?',
    'assets.drawer.taskSource.link': 'Link existing',
    'assets.drawer.taskSource.create': 'Create new',
    'assets.drawer.linkTask.title': 'Select a task',
    'assets.drawer.linkTask.placeholder': 'Choose a task\u2026',
    'assets.drawer.linkTask.required': 'Please select a task',
    'assets.drawer.linkTask.empty':
      'No unattached tasks available for this site. Create a task template in the Admin page or wait for the scheduler to generate one.',
    'assets.drawer.linkTask.search': 'Search or choose a task\u2026',
    'assets.drawer.linkTask.submit': 'Link Task',
    'assets.drawer.linkTask.description':
      'This links the selected task to {nodeName}. Only this occurrence is attached — the underlying task template is left untouched.',
    'assets.drawer.createTask.description':
      'Use the full task editor to create a new task for {nodeName}. The task is scoped to this item automatically.',
    'assets.drawer.createTask.open': 'Open Task Editor',
    'assets.drawer.taskScopedHint': 'This task will be scoped to the selected {kind} on save.',
    'assets.drawer.inventorySource': 'How would you like to add this inventory?',
    'assets.drawer.inventorySource.link': 'Link existing',
    'assets.drawer.inventorySource.create': 'Create new',
    'assets.drawer.createInventory.description':
      'Use the Add Inventory form to create a new item. It is linked to {nodeName} as soon as it is saved.',
    'assets.drawer.createInventory.open': 'Open Add Inventory',
    'assets.drawer.linkInventory.title': 'Select an inventory item',
    'assets.drawer.linkInventory.placeholder': 'Choose an inventory item\u2026',
    'assets.drawer.linkInventory.required': 'Please select an inventory item',
    'assets.drawer.linkInventory.empty': 'No existing inventory items available on this site.',
    'assets.drawer.linkInventory.submit': 'Link Inventory',
    'assets.drawer.linkInventory.description':
      'Attach an existing site inventory item to {nodeName}. The item stays in site inventory and can be unlinked at any time.',
    'assets.drawer.linkInventory.itemOnlyHint':
      'Inventory can only be linked to individual items. Select an item from the sidebar to link inventory.',

    // Daily Task Form
    'assets.drawer.taskName': 'Task Name',
    'assets.drawer.taskNamePlaceholder': 'e.g., Check suction pressure',
    'assets.drawer.taskNameRequired': 'Task name is required',
    'assets.drawer.frequency': 'Frequency',
    'assets.drawer.taskType': 'Type',
    'assets.drawer.instructions': 'Instructions',
    'assets.drawer.instructionsPlaceholder': 'Step-by-step instructions for the technician...',
    'assets.drawer.requirePhoto': 'Require photo on completion',
    'assets.drawer.markCritical': 'Mark as critical task',
    'assets.drawer.sendNotification': 'Send notification if missed',
    'assets.drawer.addTask': 'Add Task',

    // PM Form
    'assets.drawer.pmName': 'Task Name',
    'assets.drawer.pmNamePlaceholder': 'e.g., Grease bearing',
    'assets.drawer.pmNameRequired': 'Task name is required',
    'assets.drawer.interval': 'Interval',
    'assets.drawer.intervalPlaceholder': 'e.g., Every 5,000 cars',
    'assets.drawer.priority': 'Priority',
    'assets.drawer.procedure': 'Procedure',
    'assets.drawer.procedurePlaceholder': 'Describe the maintenance procedure...',
    'assets.drawer.addPmTask': 'Add PM Task',

    // Work Order Form
    'assets.drawer.projectName': 'Work Order Name',
    'assets.drawer.projectNamePlaceholder': 'e.g., Replace motor',
    'assets.drawer.projectNameRequired': 'Work order name is required',
    'assets.drawer.projectDescription': 'Description',
    'assets.drawer.projectDescriptionPlaceholder': 'Describe the work order scope...',
    'assets.drawer.addProject': 'Add Work Order',

    // Inventory Form
    'assets.drawer.itemName': 'Item Name',
    'assets.drawer.itemNamePlaceholder': 'e.g., Motor oil',
    'assets.drawer.itemNameRequired': 'Item name is required',
    'assets.drawer.requiredQty': 'Required Qty',
    'assets.drawer.requiredQtyPlaceholder': 'e.g., 2 qt',
    'assets.drawer.addInventory': 'Add Inventory Item',
    'assets.drawer.editInventory': 'Edit Inventory Item',
    'assets.drawer.editTask': 'Edit Task',

    // Group Form
    'assets.drawer.newGroup': 'New Group',
    'assets.drawer.groupName': 'Group Name',
    'assets.drawer.groupNamePlaceholder': 'e.g., Hydraulic System',
    'assets.drawer.groupNameRequired': 'Group name is required',
    'assets.drawer.groupDescription': 'Description',
    'assets.drawer.groupDescriptionPlaceholder': 'Describe this group...',
    'assets.drawer.addGroup': 'Add Group',
    'assets.drawer.editGroup': 'Edit {nodeName}',
    'assets.drawer.saveGroup': 'Save Group',

    // Asset Form
    'assets.drawer.newAsset': 'New Sub-Asset',
    'assets.drawer.assetName': 'Sub-Asset Name',
    'assets.drawer.assetNamePlaceholder': 'e.g., Hydraulic Pump',
    'assets.drawer.assetNameRequired': 'Sub-asset name is required',
    'assets.drawer.assetGroup': 'Group',
    'assets.drawer.assetGroupPlaceholder': 'Select a group...',
    'assets.drawer.assetGroupRequired': 'Group is required',
    'assets.drawer.assetNotes': 'Notes',
    'assets.drawer.assetNotesPlaceholder': 'Any notes about this sub-asset...',
    'assets.drawer.position': 'Position',
    'assets.drawer.installedAt': 'Installed date',
    'assets.drawer.addAsset': 'Add Sub-Asset',
    'assets.drawer.editAsset': 'Edit {nodeName}',
    'assets.drawer.saveAsset': 'Save Sub-Asset',

    // Template Form
    'assets.drawer.editTemplate': 'Edit {nodeName}',

    // Group Detail
    'assets.groupDetail.title': 'GROUP',
    'assets.groupDetail.description': 'Description',
    'assets.groupDetail.noDescription': 'No description',
    'assets.groupDetail.associatedTemplates': 'Associated Templates',
    'assets.groupDetail.noTemplates': 'Not associated with any templates',
    'assets.groupDetail.associatedItems': 'Sub-Assets in this Group',
    'assets.groupDetail.noItems': 'No sub-assets in this group',
    'assets.groupDetail.childGroups': 'Child Groups',
    'assets.groupDetail.noChildGroups': 'No child groups',
    'assets.groupDetail.createdAt': 'Created',

    // Item Detail
    'assets.itemDetail.title': 'SUB-ASSET',
    'assets.itemDetail.notes': 'Notes',
    'assets.itemDetail.noNotes': 'No notes',
    'assets.itemDetail.associatedGroups': 'Associated Groups',
    'assets.itemDetail.noGroups': 'Not associated with any groups',
    'assets.itemDetail.associatedTemplates': 'Associated Templates',
    'assets.itemDetail.noTemplates': 'Not associated with any templates',
    'assets.itemDetail.createdAt': 'Created',
  },
};

export default assetsMessages;
